import { styled } from "@mui/material/styles";
import { Typography as MuiTypography } from "@mui/material";

export const SectionHeaderTitle = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._200,
  flexGrow: 1,
}));

export const SessionSelectionContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._600,
}));

export const SessionCardsGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  alignSelf: "stretch",
  gap: theme.space._700,
  
  "@media (max-width: 1280px)": {
    gridTemplateColumns: "1fr",
    gap: theme.space._600,
    justifyContent: "center"
  },
}));

export const StepTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors["neutral.400"],
}));

export const SectionTitleTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["5xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors.white,
}));